import * as stylex from '@stylexjs/stylex';
import { MdInterests, MdCheck } from 'react-icons/md';
import { LabeledSection } from '~pages/Profile/components/LabeledSection';
import { styles } from './styles';
import type { PublicInterest } from '~pages/Profile/query';
export function Interests({
  interests
}: {
  interests: PublicInterest[];
}) {
  if (interests.length === 0) return null;
  return <LabeledSection label="Interests" icon={<MdInterests size={18} {...stylex.props(styles.icon)} />}>
      <div {...stylex.props(styles.chips)}>
        {interests.map(interest => <span key={interest.id} {...stylex.props(styles.chip)}>
            <MdCheck size={14} {...stylex.props(styles.check)} />
            {interest.name}
          </span>)}
      </div>
    </LabeledSection>;
}